import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import ScrollIndicator from '../components/ScrollIndicator';
import './AssessmentPage.css';

const VisitingClinicPage = ({
  seo,
  location,
  regionPhrase,
  introExtra,
}) => (
  <div className="page-assessment" data-testid="visiting-clinic-page">
    <SEO
      title={seo.title}
      description={seo.description}
      canonicalUrl={seo.canonicalUrl}
    />
    <ScrollIndicator />

    {/* Hero */}
    <section id="main-content" className="interior-hero" data-testid="page-hero">
      <div className="container">
        <span className="section-label">Visiting Clinics</span>
        <h1 className="heading-hero">Autism, ADHD &amp; Learning Assessments in {location}</h1>
      </div>
    </section>

    {/* Intro */}
    <section className="assess-section scroll-reveal" data-testid="clinic-intro">
      <div className="container assess-narrow">
        <div className="assess-intro-content">
          <p className="body-medium">
            Clinical Minds Psychology runs regular visiting assessment clinics in {location}, bringing full neurodevelopmental assessments to families and adults in {regionPhrase}. Every assessment is done personally by Lachlan Beaton, Clinical Psychologist (Registrar), nothing outsourced.{introExtra ? ` ${introExtra}` : ''}
          </p>
        </div>
      </div>
    </section>

    {/* What's offered */}
    <section className="assess-section assess-alt scroll-reveal" data-testid="clinic-offered">
      <div className="container assess-narrow">
        <h2 className="heading-1">What's offered in {location}</h2>
        <div className="assess-body">
          <p className="body-medium">
            Full assessments for autism, ADHD, FASD, learning disorders (including what's commonly called dyslexia, formally Specific Learning Disorder) and intellectual disability, for children, teens and adults.
          </p>
        </div>
      </div>
    </section>

    {/* How visiting clinic assessments work */}
    <section className="assess-section scroll-reveal" data-testid="clinic-how-works">
      <div className="container assess-narrow">
        <h2 className="heading-1">How visiting clinic assessments work</h2>
        <div className="assess-body">
          <p className="body-medium">
            The assessment involves the same steps wherever you're seen, but for visiting clinics it's arranged so you only travel once. The first hour, with parents, or with you directly for adult assessments, happens by Zoom before the clinic, so nothing on the day is used up by background and paperwork. Both assessment sessions then happen during a single clinic visit, on separate days, usually one day after the next, because seeing how a person meets the world across different days is part of what makes the assessment thorough. The feedback session and personal profile follow by telehealth afterwards. One trip, a full assessment, nothing lesser about it.
          </p>
        </div>
      </div>
    </section>

    {/* Booking */}
    <section className="assess-section assess-alt scroll-reveal" data-testid="clinic-booking">
      <div className="container assess-narrow">
        <h2 className="heading-1">Booking</h2>
        <div className="assess-body">
          <p className="body-medium">
            Clinic dates fill ahead of each visit. Enquire early via the <Link to="/contact" className="inline-link">contact page</Link>, phone or email, and mention {location} so we can plan around the next clinic dates.
          </p>
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="assess-cta-section" data-testid="clinic-cta">
      <div className="container assess-narrow" style={{ textAlign: 'center' }}>
        <Link to="/contact" className="btn btn-primary" data-testid="clinic-cta-button">
          Make an Enquiry
        </Link>
      </div>
    </section>
  </div>
);

export default VisitingClinicPage;
